export enum CurrencySymbol {
    usd = '$',
    cad = 'CA$',
    gbp = '£',
    eur = '€',
    jpy = '¥',
    brl = 'R$',
    inr = '₹',
    aud = 'AU$',
}
